import { FlightState } from "@/lib/redux/features/flight/type"

export const sortCheapest = (state: FlightState, flightId1: any, flightId2: any) => {
  const flightsResult = state.flightsResult

  const inventory2 = flightsResult.flights[flightId1].inventories[0]
  const inventory1 = flightsResult.flights[flightId2].inventories[0]
  if (state.currentModeShowPrice === 'basic_1_adult') {
    return inventory2.fareAdt  - inventory1.fareAdt
  }
  return parseFloat(`${inventory2.totalAmount}`) - parseFloat(`${inventory1.totalAmount}`)
}